import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import React from 'react'
import {remCalc} from '../../../theme/_utils'

const OrderSummaryDivider = () => {
    return <Box w={'100%' + remCalc(48)} h={remCalc(2)} bg="white" marginX={remCalc(-24)}></Box>
}

export default OrderSummaryDivider
